module.exports = __webpack_public_path__ + "static/og_image-6fc2146de9a3cf82890066da2a56c28c.png";